<template>
  <div>
    <v-dialog v-model="value" persistent max-width="600px" scrollable>
      <v-card>
        <v-form>
          <v-card-title class="headline gradiente lighten-2 elevation-3">
            <span class="white--text">{{ title }}</span>
          </v-card-title>
          <v-card-text style="text-align: center; padding: 5px">
            <v-container grid-list-md style="padding-bottom:0px">
              <v-layout wrap>
                    <p style="font-size: 18px;">{{ text }}</p>
              </v-layout>
            </v-container>
          </v-card-text>

          <v-card-text style="text-align: center; padding: 5px">
            
                <v-radio-group
                v-model="fileTypeModal"
                column
                >
                <v-layout align-center justify-center>
                        <v-flex xs4 md4 lg4 style="margin-right:20px">
                            <v-radio
                                label="XLSX"
                                color="red"
                                value="xlsx"
                            ></v-radio>
                        </v-flex>
                        <v-flex xs4 md4 lg4>
                            <v-radio
                                label="PDF"
                                color="red"
                                value="pdf"
                            ></v-radio>
                    </v-flex>
                </v-layout>


                </v-radio-group>


          </v-card-text>

          <v-card-text style="text-align: center;" v-show="cond">
            <v-btn round color="gradiente" style="background: #EF5350; " class="white--text but" @click="cancel" >Cancelar</v-btn>
            <v-btn round color="gradiente" style="background: #EF5350; " class="white--text but" @click="download" >Descargar</v-btn>

          </v-card-text>

        </v-form>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  components:{
  },
  props: ["value", "text", "title", "cond"],
  data: () => ({
        fileTypeModal: 'xlsx',
  }),
  methods: {
    cancel() {
      this.$emit("cancelled");
    },

    download() {
      this.$emit("downloaded", this.fileTypeModal);
    }
  },
  computed: {
    
  },
  mounted() {
      
  },
};
</script>

<style>
.but{
  background: #EF5350; 
  height: 37px; 
  width: 150px;
}

.card_custom {
    padding: 5px !important;
    width: 100%;
}
</style>
